import { Route, Routes } from 'react-router';
import { CssBaseline, ThemeProvider } from '@mui/material';

import { AgentsPage } from 'pages/agents';
import { Analytics } from 'pages/analytics';
import { Calendar } from 'pages/calendar';
import { ChatPage } from 'pages/chat';
import { InstructionsPage } from 'pages/instructions';
import { Reports } from 'pages/reports';
import { ApiKeysPage } from 'pages/api-keys';
import { SupportPage } from 'pages/support';

import { Layout } from './layout/Layout';
import { ROUTES } from './paths';
import { createTheme } from './theme';

import './global.css';

const theme = createTheme({
  colorPreset: 'blue',
  contrast: 'normal',
  paletteMode: 'light',
  responsiveFontSizes: true,
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <Routes>
        <Route element={<Layout />}>
          <Route
            path={ROUTES.INSTRUCTIONS}
            element={<InstructionsPage />}
          />
          <Route
            path={ROUTES.CALENDAR}
            element={<Calendar />}
          />
          <Route
            path={ROUTES.ANALYTICS}
            element={<Analytics />}
          />
          <Route
            path={ROUTES.REPORTS}
            element={<Reports />}
          />
          <Route
            path={ROUTES.API_KEYS}
            element={<ApiKeysPage />}
          />
          <Route
            path={ROUTES.CHAT}
            element={<ChatPage />}
          />
          <Route
            path={ROUTES.AGENTS}
            element={<AgentsPage />}
          />
          <Route
            path={ROUTES.SUPPORT}
            element={<SupportPage />}
          />
        </Route>
      </Routes>
    </ThemeProvider>
  );
}
export default App;
